import React, { forwardRef, useImperativeHandle, useState } from 'react'
import DatePicker, { ReactDatePickerProps, registerLocale } from 'react-datepicker'
import { ControllerRenderProps } from 'react-hook-form'
import de from 'date-fns/locale/de'

//@ts-ignore
const MobileDatePickerButton = propsArray => (
  <button
    className='form-control'
    style={{ paddingLeft: '0px' }}
    onClick={propsArray.onClick}
  >
    {propsArray.value}
  </button>
)

type CustomOptions = {
  defaultValue?: Date
  isMobile?: boolean
}

export interface CustomDatePickerRef {
  getStateVariable: () => string;
}

const CustomDatePicker = forwardRef<CustomDatePickerRef, ControllerRenderProps & ReactDatePickerProps & CustomOptions>((props, ref) => {

  const [value, setValue] = useState(props.defaultValue)

  useImperativeHandle(ref, () => ({
    getStateVariable: () => value ? value.toString() : '',
  }))

  registerLocale('de', de)

  return (
    <DatePicker
      {...props}
      onChange={(date) => setValue(date || undefined)}
      selected={value}
      clearButtonTitle='Eingabe löschen'
      popperPlacement='top'
      todayButton='Heute'
      dateFormat='dd.MM.yyyy'
      locale='de'
      dropdownMode='select'
      // mobile specialties
      peekNextMonth={props.isMobile}
      showMonthDropdown={props.isMobile}
      showYearDropdown={props.isMobile}
      withPortal={props.isMobile}
      //TODO: broken: customInput={props.isMobile ? <MobileDatePickerButton/>: undefined}
    />
  )
})

export default CustomDatePicker